import { Injector } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthFlowType } from '../enum/auth/auth-flow-type.enum';
import { AuthManagerBase } from '../interface/auth-manager-base';
import { AuthManagerPwaService } from '../manager/auth/auth-manager-pwa.service';
import { AuthManagerPwdService } from '../manager/auth/auth-manager-pwd.service';

export function initAuthManagerFactory(injector: Injector, store: Store): AuthManagerBase {
    const flow = store.selectSnapshot(s => s.AuthState?.realm?.defaultAuthenticationFlow) as AuthFlowType;

    switch (flow) {
        case AuthFlowType.OTP:
            return injector.get(AuthManagerPwaService);
        case AuthFlowType.PASSWORD:
            return injector.get(AuthManagerPwdService);
        default:
            console.error('Invalid authentication flow', flow);
            throw new Error('Invalid authentication flow');
    }
}
